/**
 * このゲーム固有の設定スライス。
 *
 * **項目がゼロでもスライスは要る**（`GameEntry.settings` が必須）。
 * `read`/`apply`/`reset` の3つを揃えるのが約束で、項目を足すときも3か所同時に触る。
 *
 * ※ 音量・BGM・言語は**ポータル横断**（`hongsoft.*`）なので、ここには置かない。
 *   所属の決め方は CLAUDE.md の「設定は所属で2つに分かれる」を参照。
 */
import type { GameSettingsSlice } from '@/platform/net/settings';
import { GAME_KEY } from '../gameKey';

/** 現状このゲームに固有の設定は無い。 */
export function resetGameSettings(): void {
  // 保存している値が無いので何もしない
}

export const slideSettingsSlice: GameSettingsSlice = {
  gameKey: GAME_KEY,
  read: () => ({}),
  apply: () => {
    // 受け取る項目が無い
  },
  reset: resetGameSettings,
};
